import moment from 'moment';
import Model  from 'alto-orm/lib/orm/model';

export default class Terminal extends Model {
  static accusativeName  = 'terminál';
  static attrNameMapping = { defaultCanteenID: 'default_canteen' };

  static serialize(terminal) {
    const row = super.serialize(terminal);

    if (terminal.registeredAt) { row.registered_at = terminal.registeredAt.format(); }

    return row;
  }

  static deserialize(row) {
    const terminal = super.deserialize(row);

    terminal.registeredAt = moment(row.registered_at);

    return terminal;
  }
};
